"use client";

interface RedirectLoadingOverlayProps {
  message: string;
}

export default function RedirectLoadingOverlay({
  message,
}: RedirectLoadingOverlayProps) {
  return (
    <div
      className="fixed inset-0 z-[10050] flex items-center justify-center bg-bg/90 backdrop-blur-sm"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex flex-col items-center gap-4 rounded-2xl border border-line bg-surface px-10 py-8 shadow-lg">
        <span className="loading loading-spinner loading-lg text-primary" />
        <p className="text-center text-sm font-semibold text-ink">{message}</p>
      </div>
    </div>
  );
}
